module.exports = __webpack_public_path__ + "static/img/undraw_segmentation_uioo.7bdd63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_segmentation_uioo.png
// module id = icMo
// module chunks = 3